import { DotLottiePreparationError } from './dotlottie-types';

const SANITY_FILES_HOST = 'cdn.sanity.io';

const identityError = (message: string) =>
  new DotLottiePreparationError({ stage: 'identity', message });

export const extractSanityFileIdentity = (url: string): string => {
  let parsedUrl: URL;
  try {
    parsedUrl = new URL(url);
  } catch {
    throw identityError('Invalid remote Lottie URL');
  }

  if (parsedUrl.protocol !== 'https:' || parsedUrl.hostname !== SANITY_FILES_HOST) {
    throw identityError('Remote Lottie is not an HTTPS Sanity file asset');
  }

  const pathParts = parsedUrl.pathname.split('/');
  if (
    pathParts.length !== 5 ||
    pathParts[1] !== 'files' ||
    !/^[A-Za-z0-9_-]+$/.test(pathParts[2]) ||
    !/^[A-Za-z0-9_-]+$/.test(pathParts[3])
  ) {
    throw identityError('Invalid Sanity file path');
  }

  const fileMatch = /^([A-Za-z0-9]+)\.lottie$/i.exec(pathParts[4]);
  if (!fileMatch) {
    throw identityError('Sanity file is not an immutable dotLottie asset');
  }

  return `${fileMatch[1].toLowerCase()}.lottie`;
};
